import { render, staticRenderFns } from "./StateWaitingForInformation.vue?vue&type=template&id=bbbcecac&scoped=true&lang=html&"
import script from "./StateWaitingForInformation.vue?vue&type=script&lang=js&"
export * from "./StateWaitingForInformation.vue?vue&type=script&lang=js&"
import style0 from "./StateWaitingForInformation.vue?vue&type=style&index=0&id=bbbcecac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbbcecac",
  null
  
)

component.options.__file = "StateWaitingForInformation.vue"
export default component.exports